import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Sidebar } from '../../../layout/components';
import { SidebarList } from '../../../layout/styles';

function TagsSidebar(props, { __ }) {
  const { Title } = Sidebar.Section;

  return (
    <Sidebar>
      <Sidebar.Section>
        <Title>{__('Tags')}</Title>
        <SidebarList>
          <li>
            <NavLink activeClassName="active" to="/tag">
              {__('Conversation')}
            </NavLink>
          </li>
        </SidebarList>
      </Sidebar.Section>
    </Sidebar>
  );
}

TagsSidebar.contextTypes = {
  __: PropTypes.func
};

export default TagsSidebar;



// WEBPACK FOOTER //
// src/modules/screens/settings/Tag/sidebar.js